import React from 'react';
import { useParams } from 'react-router-dom';
import UserService from '../services/UserService';
import SEO from './SEO';
import DealListPage from './DealListPage';

function Search() {
  let { searchstring } = useParams();

  return (
    <>
      <SEO title={`Search: ${searchstring}`} />
      <DealListPage
        title={`Results for "${searchstring}"`}
        crumb="Search"
        loadDeals={() => UserService.getSearchDeals(searchstring)}
        reloadKey={searchstring}
        emptyText={`No deals found for "${searchstring}". Try a store name like Amazon or a word like "bag".`}
      />
    </>
  );
}

export default Search;
